import { render, staticRenderFns } from "./PageSubTitle.vue?vue&type=template&id=19e461fe&functional=true&"
import script from "./PageSubTitle.vue?vue&type=script&lang=ts&"
export * from "./PageSubTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports